"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = __importDefault(require("@meeva/smart-admin-bundle/js/meeva/app"));
const jquery_1 = __importDefault(require("jquery"));
class ActionConfirmationPlugin {
    init() {
        this.container = (0, jquery_1.default)("body");
        if (this.container.length !== 1) {
            return;
        }
        this.container.on("click.ActionConfirmation", ".action-confirmation", e => this.onActionConfirmationRequired(e));
    }
    // eslint-disable-next-line class-methods-use-this
    destroy() {
        if (this.container && this.container.length > 0) {
            this.container.off("click.ActionConfirmation", ".action-confirmation");
        }
        this.container = undefined;
    }
    // eslint-disable-next-line class-methods-use-this
    async onActionConfirmationRequired(e) {
        e.preventDefault();
        e.stopPropagation();
        const eventTarget = (0, jquery_1.default)(e.currentTarget).is("a, button") ? (0, jquery_1.default)(e.currentTarget) : (0, jquery_1.default)(e.currentTarget).closest("a, button");
        const { confirmationIcon, confirmationTitle, confirmationHref, confirmationButtons, confirmationProceedButton, confirmationMessage, confirmationMethod, confirmationFunction, confirmationValue } = eventTarget.data();
        jquery_1.default.SmartMessageBox({
            title: `<i class="fa ${confirmationIcon
                || "fa-times txt-color-red"}"></i> ${confirmationTitle}`,
            content: confirmationMessage || "",
            buttons: confirmationButtons || "[Abbrechen][OK]"
        }, (buttonPressed) => {
            if (buttonPressed !== (confirmationProceedButton || "OK")) {
                return;
            }
            switch (confirmationMethod) {
                case "function":
                    window[confirmationFunction] && window[confirmationFunction].apply(null, [confirmationValue]);
                    return;
                case "none":
                case "close":
                    return;
                case "redirect":
                case "get":
                case "form_get":
                    window.location.href = confirmationHref;
                    break;
                case "form_submit":
                    eventTarget
                        .parents("form")
                        .append((0, jquery_1.default)("<input />").attr("type", "hidden").attr("name", eventTarget.attr("name") || "").val(eventTarget.val() || ""))
                        .trigger("submit");
                    break;
                case "form_post":
                default:
                    (0, jquery_1.default)("<form></form>")
                        .attr("method", "post")
                        .attr("action", confirmationHref)
                        .appendTo("body")
                        .trigger("submit");
                    break;
            }
        });
    }
}
exports.default = ActionConfirmationPlugin;
app_1.default.loadAndRegister("ActionConfirmationPlugin", () => new ActionConfirmationPlugin());
